import { useEffect, useState } from "react";

export function useShouldSubmitOnEnter(): boolean {
  const [value, setValue] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(hover: hover) and (pointer: fine)");

    const update = () => setValue(media.matches);

    update();

    media.addEventListener("change", update);

    return () => media.removeEventListener("change", update);
  }, []);

  return value;
}
